import Lara from "@/presets/lara";

export const customPricingPresets = {
  ...Lara,
  inputtext: {
    ...Lara.inputtext,
    root: (args) => ({
      class: ["!rounded-full", ...Lara.inputtext.root(args).class],
    }),
  },
};

export const customPricingTablePresets = {
  ...Lara,
  datatable: {
    ...Lara.datatable,
    thead: (args) => ({
      class: [...Lara.datatable.thead(args).class],
    }),
  },
  actionButton: {
    ...Lara.button,
    label: { class: ["uppercase", "text-base"] },
  },
};

export const customPricingFiltersPresets = {
  sidebar: {
    ...Lara.sidebar,
    header: [...Lara.sidebar.header.class, "!bg-teal-accent", "!py-3"],
    closeButtonIcon: [...Lara.sidebar.closeButtonIcon.class, "!text-university-primary"],
    content: { class: [...Lara.sidebar.content.class, "flex", "flex-col", "justify-between", "!p-0"] },
    root: (args) => ({ class: [...Lara.sidebar.root(args).class, "!w-[480px]"] }),
  },
  accordion: {
    root: {
      class: ["mb-1", "border-solid", "border-b", "border-slate-200"],
    },
    accordiontab: {
      header: ({ props }) => ({
        class: [
          { "select-none pointer-events-none cursor-default opacity-60": props?.disabled },
          "my-6",
          "font-montserrat",
          "text-normal",
          "!font-normal",
          "text-gray-900",
          "capitalize",
        ],
      }),
      headerAction: ({ context }) => ({
        class: [
          "leading-none",
          "flex flex-row-reverse items-center justify-between",
          "relative",
          "text-surface-600 dark:text-surface-0/80",
          { "text-surface-900": context.active },
          "transition duration-200 ease-in-out",
          "transition-shadow duration-200",
          "hover:text-surface-900",
          "focus:outline-none focus:outline-offset-0 focus-visible:ring focus-visible:ring-primary-400/50 ring-inset dark:focus-visible:ring-primary-300/50",
          "cursor-pointer no-underline select-none",
        ],
      }),
      headerIcon: { class: "inline-block m-1" },
      headerTitle: { class: "" },
      content: { class: ["flex-col justify-between"] },
      toggleableContent: { class: [] },
      transition: {
        enterFromClass: "max-h-0",
        enterActiveClass: "overflow-hidden transition-[max-height] duration-1000 ease-[cubic-bezier(0.42,0,0.58,1)]",
        enterToClass: "max-h-[1000px]",
        leaveFromClass: "max-h-[1000px]",
        leaveActiveClass: "overflow-hidden transition-[max-height] duration-[450ms] ease-[cubic-bezier(0,1,0,1)]",
        leaveToClass: "max-h-0",
      },
    },
  },
  button: {
    ...Lara.button,
    label: () => ({ class: ["uppercase", "font-light", "text-normal"] }),
    root: () => ({ class: [] }),
  },
};
